import { useState } from 'react';
import { Link } from 'react-router-dom';
import "./index.css";
import calloutImage from '../../assets/images/callout.webp'
import staffVioletImage from '../../assets/images/staff-violet.webp'
import serviceIcon3dPrint from '../../assets/images/service-icon-3dprint.webp'
import serviceIconApps from '../../assets/images/service-icon-apps.webp'
import serviceIconConsulting from '../../assets/images/service-icon-consulting.webp'
import serviceIconWebsite from '../../assets/images/service-icon-website.webp'
import serviceIconClients from '../../assets/images/service-icon-clients.png'

const offerings = [
  { title: "Custom 3D prints", icon: serviceIcon3dPrint, path: "/services/3dprints", linkLabel: "More Info" },
  { title: "Websites", icon: serviceIconWebsite, path: "/services/websites", linkLabel: "More Info" },
  { title: "App development", icon: serviceIconApps, path: "/services/appdev", linkLabel: "More Info" },
  { title: "Tech consulting", icon: serviceIconConsulting, path: "/services/consulting", linkLabel: "More Info" },
  { title: "Clients", icon: serviceIconClients, path: "/partners", linkLabel: "See our Clients and Partners" },
];

const About = () => {
  const [selectedOffering, setSelectedOffering] = useState<string | null>(null);

  return (
    <div className="about-page">
      <section className="about-hero">
        <div className="about-hero-image-wrap">
          <img
            src={staffVioletImage}
            alt="Hogcloud character"
            className="about-hero-image"
            onError={(event) => {
              event.currentTarget.src = calloutImage;
            }}
          />
        </div>
        <div className="about-hero-copy">
          <h1>What we offer</h1>
          <div className="about-offerings" aria-label="What Hogcloud offers">
            {offerings.map((offering) => (
              <div
                className={`about-offering ${selectedOffering === offering.title ? 'active' : ''}`}
                key={offering.title}
              >
                <button
                  type="button"
                  className="about-offering-select"
                  onClick={() => setSelectedOffering(offering.title)}
                >
                  <img src={offering.icon} alt="" aria-hidden="true" />
                  <span className="about-offering-title">{offering.title}</span>
                </button>
                {selectedOffering === offering.title && (
                  <Link className="about-offering-link" to={offering.path}>
                    {offering.linkLabel}
                  </Link>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="about-contact-callout">
        <div className="about-contact-copy">
          <p className="about-kicker">Have an idea?</p>
          <h2>Tell us what you want to make or build.</h2>
          <p>
            Whether you need a custom print, a website, an app, or tech help,
            we would love to hear from you.
          </p>
          <a href="/contact" className="about-button">
            Contact Us
          </a>
        </div>
        <div className="about-story">
          <h1>A Family business</h1>
          <p>
            We are based in Fayetteville, Arkansas, and work with local families,
            creators, and small businesses.
          </p>

          <p>
            Our work is straightforward: listen to the idea, help shape it, and
            build something that fits.
          </p>

          <div className="legal-note">
            <p>
              Hogcloud, Inc. is a registered Arkansas S-Corporation located in Fayetteville,
              Arkansas. We are not affiliated with, endorsed by, or sponsored by the
              University of Arkansas, the Arkansas Razorbacks, or any of their associated
              organizations. We are simply proud members of the Fayetteville community who
              love supporting the Razorbacks as fans.
            </p>
          </div>
        </div>
      </section>

      <section className="video-section">
        <div className="video-section-header">
          <p className="about-kicker">See more</p>
          <h2>Watch the Hogcloud story</h2>
        </div>
        <div className="video-card">
          <iframe
            width="400"
            height="225"
            src="https://www.youtube.com/embed/f2cfllgW4iM?si=RIVntXh0HoNkRKNa"
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
          ></iframe>
          <a
            href="https://www.youtube.com/watch?v=f2cfllgW4iM"
            className="video-link"
            target="_blank"
            rel="noreferrer"
          >
            Watch on YouTube
          </a>
        </div>
      </section>
    </div>
  );
};

export default About;
